"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNiceDate = exports.ErrDataReducer = exports.Deploy = void 0;
exports.Deploy = {
    CDK: 'CDK',
};
const ErrDataReducer = (results) => results.reduce((acc, curr) => {
    const mutant = {
        err: curr.err ? (acc.err ? new Error(acc.err.message + '\n' + curr.err?.message) : new Error(curr.err?.message)) : acc.err,
        data: curr.data ? (acc.data ? [...acc.data, curr.data] : [curr.data]) : acc.data
    };
    return mutant;
}, { err: null, data: null });
exports.ErrDataReducer = ErrDataReducer;
const getNiceDate = (timestamp, format = { weekday: 'short', day: 'numeric', month: 'short' }) => {
    let timestampNum = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
    let timestampMsSecs = timestampNum < 9999999999 ? timestampNum * 1000 : timestampNum;
    const datetime = new Date(timestampMsSecs);
    const nowString = new Date().toLocaleDateString('en-NZ', format);
    const thenStrting = datetime.toLocaleDateString('en-NZ', format);
    const isToday = nowString === thenStrting;
    const dateSt = format.weekday !== 'short' && isToday ? 'Today' : thenStrting;
    const timeSt = datetime.toLocaleTimeString('en-NZ', { hour: 'numeric', minute: 'numeric' });
    return `${dateSt} ${timeSt}`.replace(',', '');
};
exports.getNiceDate = getNiceDate;
